@charset "UTF-8";

/* src/app/shared/contract/contract-item/contract-thema-nego/contract-thema-nego.component.scss */
.light-flex-card {
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  margin-bottom: 20px;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
}
.header-item-filters {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  margin-bottom: 15px;
}
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px;
  margin: 0;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.item-all-content {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  font: 400 12px FranceTV Brown;
}
.guarantee-title {
  font-weight: 400 14px FranceTV Brown;
  color: #F03C64;
}
.buttons-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.margin {
  margin: 5px;
}
.item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  position: relative;
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(107, 144, 179, 0.05);
}
.item-single-row {
  padding: 0;
  background-color: transparent;
}
.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font: 400 12px FranceTV Brown;
  background-color: #FFF;
  border-radius: 5px;
  padding: 15px;
}
.item-header-and-conditions {
  display: flex;
  flex: 1;
  min-width: 0;
  justify-content: flex-start;
}
.item-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}
.item-header .channel-condition-value {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.item-header .channel-logo {
  margin-right: 0;
}
.item-header > span {
  color: #001A33;
}
.item-header .targetId {
  width: 30px;
}
.item-header .targetLabel {
  width: 180px;
}
.item-header .packLabel {
  min-width: 100px;
}
.item-header .date-range {
  width: 150px;
}
.item-header .value {
  width: 70px;
}
.item-header .nctRate {
  width: 50px;
}
.item-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-options .option-type-icon {
  height: 16px;
  margin-right: 5px;
}
.item-channels-condition {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 54px;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 5px;
  background-color: #FFF;
  font: 400 12px FranceTV Brown;
}
.item-channels-condition .channel-condition-value {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 55px;
}
.item-conditions-value {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  width: 20vw;
  max-width: 90%;
  overflow-x: auto;
}
.item-conditions-value .option-type-icon {
  height: 16px;
  width: 30px;
}
.item-conditions-value .option-condition-value {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 20px;
  margin-right: 20px;
}
.item-actions {
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
}
.item-actions > button {
  align-self: center;
  flex: 0 0 auto;
}
.conditions-container {
  min-width: 0;
  padding: 10px;
  border-radius: 5px;
  background-color: #FFF;
}
.conditions-table-scroll {
  --condition-table-header-height: 36px;
  --condition-table-row-height: 32px;
  max-height: calc(var(--condition-table-header-height) + 5 * var(--condition-table-row-height));
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
.conditions-title {
  margin: 0 0 10px;
  font: 700 12px FranceTV Brown;
  color: #F03C64;
}
.conditions-table {
  width: 100%;
  table-layout: fixed;
}
.conditions-table .mat-mdc-header-row {
  height: var(--condition-table-header-height);
}
.conditions-table .mat-mdc-row {
  height: var(--condition-table-row-height);
}
.conditions-table .mat-mdc-header-cell,
.conditions-table .mat-mdc-cell {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.conditions-table .mat-mdc-header-cell {
  background-color: #FFF;
}
.conditions-table .mat-column-category {
  width: 27%;
}
.conditions-table .mat-column-number {
  width: 96px;
}
.condition-cell-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.thema-list-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.85);
}
.channel-condition-value span,
.option-condition-value span {
  color: #001A33;
}
.item-actions mat-icon {
  cursor: pointer;
}
@keyframes fadeOutLeft {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-100%);
  }
}
.mat-expansion-panel-header {
  height: 58px;
  padding: 0 15px 0 10px;
}
.mat-expansion-indicator {
  background-color: black;
}
.mat-expansion-panel-body {
  padding: 0 0 16px !important;
}
.channel-logo {
  margin-right: 8px;
  width: 20px;
  min-height: 19px;
  height: 20px;
}
/*# sourceMappingURL=contract-thema-nego.component.css.map */
